// import React, { useEffect, useState } from 'react';
// import {
//   Container, Typography, Box, Card, CardContent, CircularProgress,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import axios from 'axios';

// const DeletedStudents = () => {
//   const [deletedStudents, setDeletedStudents] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchDeletedStudents = async () => {
//       try {
//         const response = await axios.get('https://kidsm.vercel.app/api/schools/deleted-students');
//         setDeletedStudents(response.data.deletedStudents);
//       } catch (error) {
//         console.error('Error fetching deleted students:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDeletedStudents();
//   }, []);

//   return (
//     <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
//       <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//         <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333', mb: 4 }}>
//           Deleted Students
//         </Typography>

//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
//             <CircularProgress color="primary" />
//           </Box>
//         ) : deletedStudents.length === 0 ? (
//           <Typography sx={{ fontSize: '1rem', color: '#333', textAlign: 'center', my: 4 }}>
//             No deleted students found
//           </Typography>
//         ) : (
//           deletedStudents.map((student, index) => (
//             <Card key={index} sx={{ bgcolor: '#fff', borderRadius: 2, mb: 2, boxShadow: '0 2px 6px rgba(0,0,0,0.1)' }}>
//               <CardContent>
//                 <Typography sx={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#333', mb: 0.5 }}>
//                   {student.fullName}
//                 </Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
//                   Admission: {student.admissionNumber}
//                 </Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
//                   Parent: {student.parentName}
//                 </Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
//                   Email: {student.parentEmail}
//                 </Typography>
//                 <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
//                   Contact: {student.parentContact}
//                 </Typography>
//                 <Typography sx={{ fontSize: '0.75rem', color: '#999', fontStyle: 'italic' }}>
//                   Deleted on: {new Date(student.deletedAt).toLocaleDateString()}
//                 </Typography>
//               </CardContent>
//             </Card>
//           ))
//         )}
//       </motion.div>
//     </Container>
//   );
// };

// export default DeletedStudents;

import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, Card, CardContent, CircularProgress,
} from '@mui/material';
import { motion } from 'framer-motion';
import axios from 'axios';
import { useAuth } from "../components/auth/AuthContext";

const DeletedStudents = () => {
  const [deletedStudents, setDeletedStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { schoolId } = useAuth(); // Get schoolId from auth context

  useEffect(() => {
    const fetchDeletedStudents = async () => {
      try {
        if (!schoolId) return; // Don't fetch if no schoolId
        
        const response = await axios.get(
          'https://kidsm.vercel.app/api/schools/deleted-students',
          {
            params: { schoolId } // Pass schoolId as query parameter
          }
        );
        setDeletedStudents(response.data.deletedStudents);
      } catch (error) {
        console.error('Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
      } finally {
        setLoading(false);
      }
    };

    fetchDeletedStudents();
  }, [schoolId]); // Re-fetch when schoolId changes

  return (
    <Container maxWidth="md" sx={{ py: 4, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333', mb: 4 }}>
          Deleted Students
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress color="primary" />
          </Box>
        ) : deletedStudents.length === 0 ? (
          <Typography sx={{ fontSize: '1rem', color: '#333', textAlign: 'center', my: 4 }}>
            No deleted students found
          </Typography>
        ) : (
          deletedStudents.map((student, index) => (
            <Card 
              key={index} 
              sx={{ 
                bgcolor: '#fff', 
                borderRadius: 2, 
                mb: 2, 
                boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                }
              }}
            >
              <CardContent>
                <Typography sx={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#333', mb: 0.5 }}>
                  {student.fullName}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
                  Admission: {student.admissionNumber}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
                  Parent: {student.parentName}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
                  Email: {student.parentEmail}
                </Typography>
                <Typography sx={{ fontSize: '0.875rem', color: '#666', mb: 0.5 }}>
                  Contact: {student.parentContact}
                </Typography>
                <Typography sx={{ fontSize: '0.75rem', color: '#999', fontStyle: 'italic' }}>
                  Deleted on: {new Date(student.deletedAt).toLocaleDateString()}
                </Typography>
              </CardContent>
            </Card>
          ))
        )}
      </motion.div>
    </Container>
  );
};

export default DeletedStudents;